import { START_INTRO_TOUR, RESET_INTRO_TOUR } from 'constants/ActionTypes';

const INITIAL_STATE = {
	showTour: false,
	tourPage: null
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case START_INTRO_TOUR:
			return {
				...state,
				showTour: true,
				tourPage: action.payload.page
			};
		case RESET_INTRO_TOUR:
			return {
				...state,
				showTour: false
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/Intro.js